// PasswordInput.js (version améliorée)
import React, { useState, useEffect } from 'react';
import {
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
  FormErrorMessage,
  Box,
} from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

export default function PasswordInput({ 
  value, 
  onChange, 
  placeholder, 
  showStrength = false,
  onStrengthChange,
  error,
  ...props 
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState('');

  // Validation en temps réel (optionnel)
  useEffect(() => {
    if (showStrength && onStrengthChange && value) {
      // Calcul simple de force
      let strength = 0;
      if (value.length >= 8) strength += 20;
      if (value.length >= 12) strength += 20;
      if (/[a-z]/.test(value) && /[A-Z]/.test(value)) strength += 20;
      if (/\d/.test(value)) strength += 20;
      if (/[^a-zA-Z\d]/.test(value)) strength += 20;
      onStrengthChange(Math.min(strength, 100));
    }
  }, [value, showStrength, onStrengthChange]);

  return (
    <Box width="100%">
      <InputGroup>
        <Input
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={(e) => {
            onChange(e);
            if (error) setLocalError('');
          }}
          placeholder={placeholder}
          pr="4.5rem"
          isInvalid={!!error || !!localError}
          {...props}
        />
        <InputRightElement width="4.5rem">
          <IconButton
            h="1.75rem"
            size="sm"
            onClick={() => setShowPassword(!showPassword)}
            icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
            variant="ghost"
            aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          />
        </InputRightElement>
      </InputGroup>
      {(error || localError) && (
        <FormErrorMessage mt={1}>{error || localError}</FormErrorMessage>
      )}
    </Box>
  );
}